import { useBooleanFlagValue } from "@openfeature/react-sdk";
export function useImprovedHelmTemplateValuesUI() {
    return useBooleanFlagValue("improved-helm-template-values", false);
}
